/**
 * package: com.inq.flash.client.control.messagehandlers
 * class: ChatCommunicationSurveyMessageHandler
 * @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.ChatCommunicationSurveyMessageHandler = function () {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this, com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_SURVEY);
};

$hxClasses.extend(
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler,
	com.inq.flash.client.control.messagehandlers.ChatCommunicationSurveyMessageHandler,
	"com.inq.flash.client.control.messagehandlers.ChatCommunicationSurveyMessageHandler"
);

/**
 * processMessage
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false }],TEnum(Void,[]))
 * override public function processMessage(message:Message):Void
 * @override
 * @public
 * @this com.inq.flash.client.control.messagehandlers.ChatCommunicationSurveyMessageHandler
 * @param {com.inq.flash.messagingframework.Message}  message
 * @return {void}
 */
com.inq.flash.client.control.messagehandlers.ChatCommunicationSurveyMessageHandler.prototype.processMessage = function (message) {
	/** @type {string} */
	var surveyAlias = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_MESSAGE_AGENT_ALIAS) || "";
	/** @type {string} */
	var surveyMessage = com.inq.flash.client.chatskins.SkinControl.checkMessageForSpecialExpression(message).text;
	/** @type {boolean} */
	var replay = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY) === "1";
	/** @type {number} */
	var position = parseInt(message.getProperty(com.inq.flash.client.data.MessageFields.KEY_LINE_NR)) || -1;
	/** @type {Date} */
	var messageTimestamp = message.getPropertyAsDate(com.inq.flash.client.data.MessageFields.KEY_MESSAGE_TIMESTAMP);

	surveyMessage = com.inq.flash.client.chatskins.SkinControl.prepareAsyncSurveyMessage(surveyMessage);

	if (!replay) {
		com.inq.flash.client.chatskins.SkinControl.getApplicationController().setFlagChatInQueue(false);
		com.inq.flash.client.chatskins.FocusMonitor.startTitlebarFlash();
		com.inq.flash.client.control.MinimizeManager.lastAgentMessage(surveyMessage);
		com.inq.flash.client.chatskins.SndMgr.PlaySound();
	}
	com.inq.flash.client.control.MinimizeManager.displayAgentMessageAndCount(surveyMessage);

	this.getController().appendReceivedText(surveyMessage, surveyAlias, position, false, null, replay, null, messageTimestamp, true);
};

/** @type {com.inq.flash.client.control.messagehandlers.ChatCommunicationSurveyMessageHandler} */
com.inq.flash.client.control.messagehandlers.ChatCommunicationSurveyMessageHandler.prototype.__class__ = com.inq.flash.client.control.messagehandlers.ChatCommunicationSurveyMessageHandler;
